import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'
import { Router, RouterModule } from '@angular/router'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { select, Store } from '@ngrx/store'
import {
  selectError,
  selectIsAuthenticated,
  selectLoading
} from '../../../../store/auth/auth.state'
import { login, loginFailure, loginSuccess } from '../../../../store/auth/auth.actions'
import { CommonModule, NgIf } from '@angular/common'
import { eps } from '../../../../services/url.service'
import { filter, Subject, take, takeUntil, tap } from 'rxjs'
import { selectUser } from '../../../../store/auth/auth.selectors'
import { Actions, ofType } from '@ngrx/effects'
import { StrictEmailDirective } from '../../../../directives/strict-email.directive'
import { SharedModule } from '../../../../shared/shared.module'
import { ApiCancelService } from '../../../../services/api-cancel.service'

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    CommonModule,
    RouterModule,
    StrictEmailDirective,
    SharedModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, OnDestroy {
  store = inject(Store)
  private destroy$ = new Subject<void>()
  form
  text = 'LOGIN'
  isPasswordVisible = false // Flag to toggle password visibility
  currentYear
  errorMessage$
  isLoading$ = this.store.pipe(select(selectLoading))
  actions$ = inject(Actions)
  eps = eps

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private sanitizer: DomSanitizer,
    private apiCancelService: ApiCancelService
  ) {
    this.currentYear = new Date().getFullYear()
    this.errorMessage$ = this.store.pipe(select(selectError))
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    })

    // this.actions$.pipe(ofType(loginSuccess)).subscribe(() => {
    //   this.isLoading = false
    //   this.form.reset()
    // })
    // this.actions$.pipe(ofType(loginFailure)).subscribe(() => {
    //   this.isLoading = false
    //   // this.form.reset()
    // })
  }

  ngOnInit() {
    // this.store.pipe(select(selectIsAuthenticated), takeUntil(this.destroy$)).subscribe(isAuth => {
    //   if (isAuth) {
    //     this.router.navigate([eps.user.dashboardPath])
    //   }
    // })
    this.store.pipe(select(selectIsAuthenticated), takeUntil(this.destroy$)).subscribe(isAuth => {
      if (isAuth) {
        this.store
          .select(selectUser)
          .pipe(
            take(1),
            filter(user => !!user),
            tap(user => {
              // console.log('user roles', user)
              // if (user?.role === 'Admin') {
              //   this.router.navigate([eps.user.dashboardPath])
              // } else {
              //   this.router.navigate([eps.user.employeeDashboardPath])
              // }
              const isAdmin = user?.userRoles?.some(ur => ur.role?.name === 'Admin')
              // Tawk widget me user details set karein
              if ((window as any).Tawk_API) {
                ;(window as any).Tawk_API.setAttributes(
                  {
                    name: `${user.firstName} ${user.lastName}`,
                    email: user.email
                  },
                  (error: any) => {
                    if (error) {
                      console.error(error)
                    }
                  }
                )
              }
              // if (isAdmin) {
              //   this.router.navigate([eps.user.dashboardPath])
              // } else {
              //   this.router.navigate([eps.user.employeeDashboardPath])
              // }
            })
          )
          .subscribe() // ⬅️ this is essential!
      }
    })

    this.actions$.pipe(ofType(loginFailure), takeUntil(this.destroy$)).subscribe(() => {
      this.form.patchValue({ password: '' })
    })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  authenticate() {
    // console.log(this.form.get('email')?.value)
    // console.log(this.form.get('password')?.value)
    if (this.form.valid) {
      this.form.markAsPending()
      this.store.dispatch(login(this.form.value as { email: string; password: string }))
      this.apiCancelService.resetLogout()
    }
  }

  // Toggle the visibility of the password
  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.togglePasswordVisibility()
    }
  }

  get copyrightText(): SafeHtml {
    const copyrightSymbol = '\u00A9' // Unicode for ©
    const text =
      this.currentYear === 2025
        ? `Copyright ${copyrightSymbol} 2025 - <a href="https://avrtechno.com" class="hover-a">AVR Software Pvt. Ltd.</a>`
        : `Copyright ${copyrightSymbol} 2025 - ${this.currentYear} - <a href="https://avrtechno.com" class="hover-a">AVR Software Pvt. Ltd.</a>`

    return this.sanitizer.bypassSecurityTrustHtml(text)
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
      if (control.hasError('email')) {
        return 'Please enter a valid email address'
      }
    }
    return null // No error
  }
}
